import React from 'react'

export default function TextCard(props) {
  return (
    <div className="textcard">
          <div className="heading">
            <p className="activity">{props.name}</p>
            <svg className="dots" width="21" height="5" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm8 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm8 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z" fill="#BBC0FF" /></svg>
          </div>
          <section className="timings">
            <h2>
              <span className="hrs">{props.current}</span>hrs
            </h2>
            <p className="pasttimings">Last Week - {props.previous}hrs</p>
          </section>
    </div>
  )
}
